import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getBottomState, getShowMapLegend } from "../../../ducks/layout/selectors";
import { toggleMapLegend } from "../../../ducks/layout/layout";

export const useMapLegendTableResizing = () => {
  const dispatch = useDispatch();
  const showMapLegend = useSelector(getShowMapLegend);
  const bottomState = useSelector(getBottomState);
  const [isResizing, setIsResizing] = useState(false);
  const isTableFullscreen = bottomState === "fullscreen";

  useEffect(() => {
    if (isResizing && showMapLegend) {
      dispatch(toggleMapLegend());
    }
  }, [isResizing]); // eslint-disable-line

  useEffect(() => {
    if (showMapLegend) {
      dispatch(toggleMapLegend());
    }
  }, [bottomState]); // eslint-disable-line

  return {
    isTableFullscreen,
    isResizing,
    setIsResizing,
  };
};
